export const stepOneData = [
  {
    heading: "Why Use Minemi’s EMI Calculator for Home Loans?",

    impactHead:
      "Our calculator helps you make informed decisions by providing accurate estimates and useful insights into various loan options.",

    infoList: [
      {
        head: "Accurate EMI Estimates: ",
        info: "Get precise monthly payment calculations based on your loan amount, interest rate, and tenure.",
      },
      {
        head: "Compare Loan Offers: ",
        info: "Evaluate EMIs across lenders to find the best deal that suits your budget.",
      },
      {
        head: "Understand Loan Affordability: ",
        info: "Minemi helps you understand how much you can comfortably borrow without overburdening your finances.",
      },
      {
        head: "Explore Prepayment Options: ",
        info: "Calculate how partial prepayments can reduce your EMI or loan tenure.",
      },
      {
        head: "Plan for Future Goals: ",
        info: "Simulate different scenarios and make better financial plans for your home loan journey.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "What You Can Do With the Home Loan EMI Calculator?",

    infoList: [
      {
        heading: "Estimate Monthly Payments: ",
        info: "Enter the loan amount, interest rate, and tenure to calculate your EMI instantly.",
      },
      {
        heading: "Simulate Loan Scenarios: ",
        info: "Adjust variables like tenure or interest rates to understand their impact on your EMI.",
      },
      {
        heading: " Plan Prepayments: ",
        info: "Use the calculator to evaluate how prepayments can reduce your interest burden or EMI.",
      },
    ],

    tipHead: "Choose the Right Tenure",
    tipList: [
      {
        list: "A shorter tenure means higher EMIs but lower total interest.",
      },
      {
        list: "A longer tenure reduces EMIs but increases the overall interest paid.",
      },
      {
        list: "Balance your monthly budget and total interest cost by using the EMI calculator to test different tenure options.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "Sample EMI Calculation for Home Loans",

    emiTable: {
      tableHead: [
        {
          head: "Loan Amount",
        },
        {
          head: "Interest Rate (%) ",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Interest (₹)",
        },
        {
          head: "Total Payment (₹)",
        },
      ],
      row: [
        {
          amount: "₹40,00,000",
          interestPer: "8.0%",
          tenure: "20",
          emi: "₹33,458",
          totalinterest: "₹40,29,818",
          payment: "₹80,29,818",
        },
        {
          amount: "₹50,00,000",
          interestPer: "7.5%",
          tenure: "15",
          emi: "₹46,296",
          totalinterest: "₹37,33,274",
          payment: "₹87,33,274",
        },
        {
          amount: "₹60,00,000",
          interestPer: " 8.5%",
          tenure: " 10",
          emi: " ₹73,764",
          totalinterest: " ₹27,51,638",
          payment: " ₹87,51,638",
        },
      ],
    },
    note: "Figures are indicative and may vary based on lender terms and market conditions.",
    tipHead: "Leverage Prepayment Opportunities.",
    tipList: [
      {
        list: "Make periodic lump-sum payments to reduce your loan tenure or EMI.",
      },
      {
        list: "Check with your lender about prepayment penalties or charges.",
      },
      {
        list: "Use Minemi’s prepayment calculator to see the impact on your loan.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Maximize Savings on Your Home Loan EMI",

    infoList: [
      {
        head: "Compare Interest Rates: ",
        info: "Evaluate interest rates from multiple lenders before applying. Even a 0.5% reduction in rates can lead to significant savings over the loan tenure.",
      },
      {
        head: "Opt for a Balance Transfer: ",
        info: "If your current loan has a high-interest rate, consider transferring it to a lender offering better terms. Minemi’s Balance Transfer Calculator helps you estimate savings.",
      },
      {
        head: "Monitor Your Credit Score: ",
        info: "A high credit score ensures you qualify for lower interest rates. Regularly check your score and improve it by paying EMIs and credit card bills on time.",
      },
    ],
    tipHead: "Account for Hidden Costs",
    tipList: [
      {
        list: "Don’t forget about processing fees, legal charges, and property valuation costs.",
      },
      {
        list: "Include these costs in your loan calculations to avoid surprises.",
      },
      {
        list: "Use Minemi’s calculators and guides to get a complete financial picture.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "How Credit Score Affects Interest Rates and EMI",
    subtitle:
      "Your credit score is a numerical representation of your creditworthiness. Lenders use it to assess the risk of lending to you.",

    creditScoreList: [
      {
        head: "High Credit Score (750 and above): ",
        info: "Indicates low risk, leading to lower interest rates and EMIs.",
      },
      {
        head: "Moderate Credit Score (650-749): ",
        info: "May result in standard interest rates.",
      },
      {
        head: "Low Credit Score (below 650): ",
        info: "Considered high risk, leading to higher interest rates and EMIs.",
      },
    ],

    improvingCredit: "Improving Your Credit Score:",
    improveCreditlist: [
      {
        head: "Timely Payments: ",
        info: "Always pay your EMIs and credit card bills on time.",
      },
      {
        head: "Credit Utilization Ratio: ",
        info: "Keep your credit card usage below 30% of the limit.",
      },
      {
        head: "Avoid Multiple Loan Applications: ",
        info: "Too many loan inquiries can negatively impact your score.",
      },
    ],
    tip: "Regularly check your credit report for errors and get them rectified to maintain an accurate credit score.",
  },
];
